<div class="clients-page" #clientsRoot>
  <section class="clients-hero dingo-section section-first">
    <div class="container">
      <div class="clients-hero-grid">
        <div class="clients-hero-copy">
          <div class="section-head client-reveal reveal-on-scroll" data-reveal="section-head" data-reveal-trigger="immediate">
            <p class="clients-kicker">Clientes y proyectos</p>
            <h1 class="clients-title">
              Marcas que confiaron en DIN<span class="highlight-green">GO</span> para construir
              <span class="highlight-green">crecimiento real</span>
            </h1>
            <p class="clients-desc">
              Esta página no es solo una galería. Es un mapa de colaboraciones donde estrategia, tecnología, contenido y
              ejecución se adaptaron a distintos retos de negocio.
            </p>
          </div>
        </div>

        <figure class="dingo-hero-image-stage client-reveal" data-reveal="media" data-reveal-trigger="immediate" style="--reveal-order: 2">
          <div class="dingo-hero-image-stack">
            <img class="img-fluid dingo-cutout-edge-fix" src="assets/images/clients/clients.png" alt="Casos de éxito y proyectos realizados por Grupo DINGO" />
          </div>
        </figure>
      </div>
    </div>
  </section>

  <section class="clients-logo-wall dingo-section dingo-bg-accent">
    <div class="container">
      <div class="clients-section-head section-head client-reveal reveal-on-scroll" data-reveal="section-head">
        <p class="clients-kicker">Marcas</p>
        <h2 class="clients-section-title">
          Una red de clientes en <span class="highlight-green">múltiples categorías</span>
        </h2>
      </div>

      <div class="clients-logo-grid">
        @for (logo of logos; track logo.file; let i = $index) {
        <article class="clients-logo-card client-reveal" data-reveal="card" [style.--reveal-order]="i % 6">
          <img class="img-fluid" [src]="'assets/brand/clients/' + logo.file" [alt]="logo.name" loading="lazy" />
        </article>
        }
      </div>
    </div>
  </section>

  <section class="clients-featured dingo-section dingo-bg-base">
    <div class="container">
      <div class="clients-section-head clients-section-head--split section-head client-reveal reveal-on-scroll" data-reveal="section-head">
        <div>
          <p class="clients-kicker">Case atlas</p>
          <h2 class="clients-section-title">
            Casos destacados con <span class="highlight-green">diferentes retos</span>
          </h2>
        </div>
        <p class="clients-section-desc">
          Proyectos donde estrategia, creatividad, tecnología y ejecución se conectaron para resolver objetivos
          específicos de negocio.
        </p>
      </div>

      <div class="clients-featured-grid">
        @for (project of featuredProjects; track project.title; let i = $index) {
        <a class="client-feature-card client-reveal" data-reveal="card" [style.--reveal-order]="i" [routerLink]="project.route">
          <img class="img-fluid" [src]="project.image" [alt]="project.title" loading="lazy" />
          <span>{{ project.category }}</span>
          <h3>{{ project.title }}</h3>
          <p>{{ project.description }}</p>
        </a>
        }
      </div>
    </div>
  </section>

  <section class="clients-project-atlas dingo-section dingo-bg-accent">
    <div class="container">
      <div class="clients-project-list">
        @for (project of secondaryProjects; track project.title; let i = $index) {
        <a class="client-row-card client-reveal" data-reveal="card" [style.--reveal-order]="i % 4" [routerLink]="project.route">
          <span class="client-row-index">{{ i + 4 | number: '2.0' }}</span>
          <div class="client-row-image">
            <img class="img-fluid" [src]="project.image" [alt]="project.title" loading="lazy" />
          </div>
          <div class="client-row-copy">
            <small>{{ project.category }}</small>
            <h3>{{ project.title }}</h3>
            <p>{{ project.description }}</p>
          </div>
          <i class="bi bi-arrow-up-right"></i>
        </a>
        }
      </div>
    </div>
  </section>
</div>
